import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import styles from "./TableCell.module.scss";

/**
 * The component renders a `<th>` element when the variant is a header
 * or otherwise a `<td>` element.
 */
const TableCell = forwardRef(({ className, component, scope: scopeProp, variant, ...rest }, ref) => {
  let Component;
  if (component) {
    Component = component;
  } else {
    Component = variant === "head" ? "th" : "td";
  }

  let scope = scopeProp;
  if (!scope && variant === "head") {
    scope = "col";
  }

  return <Component ref={ref} className={cn(styles.container, className)} scope={scope} {...rest} />;
});

TableCell.displayName = "TableCell";

TableCell.defaultProps = {
  children: "",
  className: undefined,
  component: undefined,
  scope: undefined,
  variant: undefined
};

TableCell.propTypes = {
  /**
   * The table cell contents.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Set scope attribute.
   */
  scope: PropTypes.string,
  /**
   * Specify the cell type.
   */
  variant: PropTypes.oneOf(["body", "footer", "head"])
};

export default TableCell;
